/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Modal, Box, Typography, Card, Stack, FormControlLabel, Switch } from '@mui/material';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css'
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import axiosInstance, { getErrorMessage } from 'utils/axios';
import { FormProvider, RHFTextField, RHFUploadAvatar } from 'components/hook-form';
import { LoadingButton } from '@mui/lab';
import CRUD from 'utils/Crud';
import { fData } from 'utils/formatNumber';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid whitesmoke',
    boxShadow: 24,
    p: 4,
};


const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    coin_id: Yup.string().required('Field is required'),
});

AddCryptoModal.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    handleComplete: PropTypes.func,
    isEdit: PropTypes.bool,
    coin: PropTypes.object
}

export default function AddCryptoModal({ open, handleClose,handleComplete, isEdit,coin }) {

    const { enqueueSnackbar } = useSnackbar();
    const [state,setState] = useState({imageRef:null, croppedImageUrl:null,});
    const [cropImage, setCropImage] = useState(null);
    const [crop, setCrop] = useState({
        unit: 'px', // Can be 'px' or '%'
        x: 25,
        y: 25,
        width: 180,
        height: 180,
        // aspect: .85 / 1,
      });

      const defaultValues = useMemo(
        () => ({
            name: coin?.name || '',
            coin_id: coin?.coin_id || '',
            allow_sell: coin?.allow_sell,
            allow_buy: coin?.allow_buy
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [coin]
    );

    const methods = useForm({
        resolver: yupResolver(NewUserSchema),
        defaultValues,
    });

    const {
        reset,
        watch,
        control,
        setValue,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const values = watch();

    const onSubmit = async () => {
        try {
            
            const formData = new FormData()
            formData.append('name', values.name);
            formData.append('coin_id', values.coin_id);
            formData.append('userfile', cropImage)

            if(isEdit){
                formData.append('allow_sell',values.allow_sell);
                formData.append('allow_buy',values.allow_buy);
                await axiosInstance.post(`${CRUD.cryptoAssets}//update`,formData);
                enqueueSnackbar('Update success!');
            }
            else {
                await axiosInstance.post(CRUD.cryptoAssets,formData);
                enqueueSnackbar('Create success!');
            }
            reset();
            handleComplete();
        } catch (error) {

        //   console.error(error);
            enqueueSnackbar(getErrorMessage(error));
        }
    };

    const handleDrop = useCallback(
        (acceptedFiles) => {
        const file = acceptedFiles[0];

        if (file) {
        setValue(
            'avatarUrl',
            Object.assign(file, {
                preview: URL.createObjectURL(file),
            })
        );
        }
    },
    [setValue]
      );

    return <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        hideBackdrop={false}
    >
        <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                {isEdit ? "Update asset" : "Add asset"}
            </Typography>

            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>

                <Card sx={{ p: 3, mt:4 }}>

                    <Box  >
                        <Box sx={{ mb: 5 }}>
                            {values.avatarUrl == null &&
                                <RHFUploadAvatar
                                    name="avatarUrl"
                                    accept="image/png,image/jpg,image/jpeg"
                                    maxSize={3145728}
                                    onDrop={handleDrop}
                                    helperText={
                                    <Typography
                                        variant="caption"
                                        sx={{
                                        mt: 2,
                                        mx: 'auto',
                                        display: 'block',
                                        textAlign: 'center',
                                        color: 'text.secondary',
                                        }}
                                    >
                                        Allowed *.jpeg, *.jpg, *.png, *.gif
                                        <br /> max size of {fData(3145728)}
                                        {isEdit && (
                                            <p>Leave empty if you dont want to update current icon</p>
                                        )}
                                    </Typography>
                                    }
                                />}
                            {values.avatarUrl != null && (
                                <Box sx={{display:"flex",justifyContent:"center"}}>
                                    <ReactCrop 
                                        crop={crop} 
                                        circularCrop
                                        onComplete={onCropComplete}  
                                        onChange={c => setCrop(c)}>
                                        <img 
                                            onLoad ={(e)=>{
                                                // console.log(image)
                                                getCroppedImg(e.currentTarget,crop);
                                                setState({...state,imageRef:e.currentTarget});
                                            }} 
                                            src={values.avatarUrl.preview} 
                                            style={{width:180}} alt="" />
                                    </ReactCrop>
                                </Box>
                                
                            ) }
                            </Box>
                        
                        <RHFTextField name="name" label="Name" sx={{mt:3}} />  
                        <RHFTextField name="coin_id" label="Coin ID/Symbol (e.g BTC, USDT)" sx={{mt:3}} />  
                        <input type='file' accept='image/*' id="userfile" style={{display:"none"}} />   

                        {isEdit && (
                            <FormControlLabel
                                labelPlacement="start"
                                sx={{ mx: 0, mb: 3, mt:3, width: 1, justifyContent: 'space-between' }}
                                control={
                                    <Controller
                                        name="allow_sell"
                                        control={control}
                                        render={({ field }) => (
                                        <Switch
                                            {...field}
                                            checked={values.allow_sell}
                                            onChange={()=> setValue('allow_sell',!values.allow_sell)}
                                        />
                                        )}
                                    />
                                }
                                label={
                                    <>
                                        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                                        Allow user sell
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        change to enable/disable action
                                        </Typography>
                                    </>
                                    }
                                />
                            )}

                            {isEdit && (
                                <FormControlLabel
                                    labelPlacement="start"
                                    control={
                                    <Controller
                                        name="allow_buy"
                                        control={control}
                                        render={({ field }) => (
                                        <Switch
                                            {...field}
                                            checked={values.allow_buy}
                                            onChange={()=> setValue('allow_buy',!values.allow_buy)}
                                        />
                                        )}
                                    />
                                    }
                                    label={
                                        <>
                                            <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                                            Allow users buy
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                            change to enable/disable action
                                            </Typography>
                                        </>
                                        }
                                        sx={{ mx: 0, mb: 3, mt:3, width: 1, justifyContent: 'space-between' }}
                                    />
                                )}
                                            
                        
                    </Box>
                    <br/>
                    <Stack alignItems="flex-end" sx={{ mt: 3 }}>
                        <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                        {isEdit ? "Update asset" : "Save asset"}
                        </LoadingButton>
                    </Stack>
                </Card>

            </FormProvider>
        </Box>
    </Modal>

    function dataURLtoFile(dataurl, filename) {
        const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]); 
            let n = bstr.length; 
            const u8arr = new Uint8Array(n);
                
        // eslint-disable-next-line no-plusplus
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        const croppedImage = new File([u8arr], filename, {type:mime});
        // setState({...state, croppedImage });
        setCropImage(croppedImage);
    }

    function getCroppedImg(image, crop) {
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext("2d");
        
        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
         );
    
        const reader = new FileReader()
        canvas.toBlob(blob => {
            reader.readAsDataURL(blob)
            reader.onloadend = () => {
                dataURLtoFile(reader.result, 'userfile.jpg')
            }
        });
    }

    function onCropComplete(crop) {
        // console.log("state",state);
        if(state.imageRef){
            getCroppedImg(state.imageRef,crop);
        }
        
    }
}
